import { useState, useCallback } from 'react';

const useChatSocketToken = () => {
  const [tokenError, setTokenError] = useState(null);

  const getChatSocketToken = useCallback(async () => {
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/chat-token`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        const errorData = await response.text();
        setTokenError('Failed to get chat token');
        throw new Error('Failed to get chat token');
      }
      
      const data = await response.json();
      
      // Handle both response structures: { success: true, data: { token } } or { token }
      const token = data.data?.token || data.token;
      
      if (!token) {
        setTokenError('Token not found in response');
        return null;
      }
      
      return token;
    } catch (error) {
      setTokenError(error.message);
      return null;
    }
  }, []);

  return { getChatSocketToken, tokenError };
};

export default useChatSocketToken;
